import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CommonFunctionService } from 'src/app/services/Common/common-function.service';
import { DataService } from 'src/app/services/data.service';
import { environment } from 'src/environments/environment';

@Injectable()
export class AccountingService {
  userId: any;
  token;
  headers: any;
  constructor(private service: DataService, private http: HttpClient,private common:CommonFunctionService) { 
    let loggedUsername =this.common.getUserName()
    this.token =environment.GetAuthenticationToken + ":" +this.common.GetAuthToken()+ ":" + "IT"+ ":"+environment.GetAuthencticationKey+":"+this.common.getSid();
    this.headers = new HttpHeaders().
    set('Authorization', 'basic ' + btoa(this.token));
  }

  GetHeaderdetails()
  {
    let loggedUsername =this.common.getUserName()
    this.token =environment.GetAuthenticationToken + ":" +this.common.GetAuthToken()+ ":" + "IT"+ ":"+environment.GetAuthencticationKey+":"+this.common.getSid();
    this.headers = new HttpHeaders().
    set('Authorization', 'basic ' + btoa(this.token));

  }

  AddSupplierDetails(data)
  {
    this.GetHeaderdetails();
    return this.http.post<any>(environment.AddSupplierDetails, data,{headers:this.headers});
  }


  AddItemAndServices(data)
  {
    this.GetHeaderdetails();
    return this.http.post<any>(environment.AddItemAndServices, data,{headers:this.headers});
  }

  GetHSNCodeDetails(data)
  {
    this.GetHeaderdetails(); // Assuming this method sets the headers
    const url = `${environment.GetHSNCodeDetails}?key=${data}`;
    return this.http.post<any>(url, {}, { headers: this.headers });
  }
}
